import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { QrCodeModule } from 'ng-qrcode';

@Component({
    selector: 'app-shared-ui-qrcode',
    standalone: true,
    imports: [CommonModule, QrCodeModule],
    templateUrl: './qrcode.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})

/**
 * Componente para mostrar un código QR
 */
export class QrcodeComponent {
    @Input() public code: string;

    @Input() public size: string;

    @Input() public margin: number = 4;

    @Input() public errorCorrectionLevel: 'L' | 'M' | 'Q' | 'H' = 'M';
}
